<template>
  <div class="ShippingRateRoot">
    <v-tabs
      v-model="tabIndex"
      slider-color="blue"
      height="35"
    >
      <v-tab
        v-if="airTypeTwp"
        ripple
        class="px-0"
      >
        空運普貨
        <span
          style="margin-right: -6px;"
          @click.stop
        >
          <ForbidTips />
        </span>
      </v-tab>
      <v-tab
        v-if="airTypeTwt"
        ripple
      >
        空運特貨
      </v-tab>
      <v-tab
        v-if="seType[0]"
        ripple
        class="px-0"
      >
        海快
        <span
          style="margin-right: -6px;"
          @click.stop
        >
          <SeForbidTips />
        </span>
      </v-tab>
      <!-- <v-tab
        v-if="seaType[0]"
        ripple
      >
        家具海運
      </v-tab> -->
      <v-tab-item
        v-if="airTypeTwp"
        lazy
      >
        <table class="shippingRateTable">
          <template v-if="!airTypeTwp.weightRanges">
            <template v-if="airTypeTwp.addlWeight > 0">
              <tr>
                <td width="70">
                  首重
                </td>
                <td>NT$ {{ airTypeTwp.fwFee }} /KG</td>
              </tr>
              <tr>
                <td>續重</td>
                <td>
                  <template v-if="viewAirFeeType==='frt'">
                    NT$ {{ $calc.add(airTypeTwp.awFee, airTypeTwp.frtFee) }} / KG
                  </template>
                  <template v-else-if="viewAirFeeType==='tax'">
                    NT$ {{ $calc.add(airTypeTwp.awFee, airTypeTwp.taxFee) }} / KG
                  </template>
                  <template v-else>
                    NT$ {{ airTypeTwp.awFee }} / KG
                  </template>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td>運費</td>
              <td>NT$ {{ airTypeTwp.fwFee }} /KG</td>
            </tr>
          </template>
          <template
            v-for="(weightRange, index) in airTypeTwp.weightRanges"
          >
            <tr :key="'weightRange' + index">
              <td width="80">
                <template v-if="weightRange">
                  <b v-if="weightRange.end < $store.state.shippingRate.weightRangeMax">
                    {{ weightRange.start | toKg }}-{{ weightRange.end | toKg }} KG
                  </b>
                  <b v-else>{{ weightRange.start | toKg }} 以上</b>
                </template>
              </td>
              <td>NT$ {{ weightRange.fee }} /KG</td>
              <!-- <td>
                NT$ {{ formatFee(item,warehouse, $store.state.transport.air) }} /KG
              </td> -->
            </tr>
          </template>
          <tr>
            <td>稅金</td>
            <td>
              <v-layout class="my-2">
                <v-spacer />
                <!-- <div
                  class="mr-2"
                  @click="viewAirFeeType='frt'"
                >
                  <v-icon
                    v-if="viewAirFeeType==='frt'"
                    small
                    class="blue--text">radio_button_checked</v-icon>
                  <v-icon
                    v-else
                    small>radio_button_unchecked</v-icon>
                  包頻繁稅
                </div> -->
                <div
                  class="mr-2 cursor-pointer"
                  @click="viewAirFeeType='busi'"
                >
                  <v-icon
                    v-if="viewAirFeeType==='busi'"
                    small
                    class="blue--text"
                  >
                    radio_button_checked
                  </v-icon>
                  <v-icon
                    v-else
                    small
                  >
                    radio_button_unchecked
                  </v-icon>
                  X3不包稅
                </div>
                <div
                  class="cursor-pointer"
                  @click="viewAirFeeType='tax'"
                >
                  <v-icon
                    v-if="viewAirFeeType==='tax'"
                    small
                    class="blue--text"
                  >
                    radio_button_checked
                  </v-icon>
                  <v-icon
                    v-else
                    small
                  >
                    radio_button_unchecked
                  </v-icon>
                  X2全包稅
                </div>
                <v-spacer />
              </v-layout>
              <!-- 個人用途包稅/商務用途不包稅<Tooltips><ShpMethodBusinessText/></Tooltips> -->
            </td>
          </tr>
          <tr>
            <td>派送</td>
            <td>
              黑貓<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText />
              </Tooltips>
              新竹<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText />
                <v-divider class="my-2" />
                <h4>標準尺寸：</h4>
                <HctCaiStandardText transport="air" />
                <v-divider class="my-2" />
                <h4>超才費：</h4>
                <HctCaiFeeText transport="air" />
                <v-divider class="my-2" />
                <h4>棧板費：</h4>
                <HctHatPalletFeeText />
              </Tooltips>
              大榮<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText carrier="ktj" />
              </Tooltips>
            </td>
          </tr>
          <tr>
            <td>合包上限</td>
            <td>每筆訂單集運上限30個包裹</td>
          </tr>
        </table>
      </v-tab-item>
      <v-tab-item
        v-if="airTypeTwt"
        lazy
      >
        <table class="shippingRateTable">
          <template v-if="!airTypeTwt.weightRanges">
            <template v-if="airTypeTwt.addlWeight > 0">
              <tr>
                <td width="70">
                  首重
                </td>
                <td>NT$ {{ airTypeTwt.fwFee }} /KG</td>
              </tr>
              <tr>
                <td>續重</td>
                <td>
                  <template v-if="viewAirFeeType==='frt'">
                    NT$ {{ $calc.add(airTypeTwt.awFee, airTypeTwt.frtFee) }} / KG
                  </template>
                  <template v-else-if="viewAirFeeType==='tax'">
                    NT$ {{ $calc.add(airTypeTwt.awFee, airTypeTwt.taxFee) }} / KG
                  </template>
                  <template v-else>
                    NT$ {{ airTypeTwt.awFee }} / KG
                  </template>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td>運費</td>
              <td>NT$ {{ airTypeTwt.fwFee }} /KG</td>
            </tr>
          </template>
          <template
            v-for="(weightRange, index) in airTypeTwt.weightRanges"
          >
            <tr :key="'weightRange' + index">
              <td width="120">
                <template v-if="weightRange">
                  <b v-if="weightRange.end < $store.state.shippingRate.weightRangeMax">
                    {{ weightRange.start | toKg }}-{{ weightRange.end | toKg }} KG
                  </b>
                  <b v-else>{{ weightRange.start | toKg }} 以上</b>
                </template>
              </td>
              <td>NT$ {{ weightRange.fee }} /KG</td>
              <!-- <td>
                NT$ {{ formatFee(item,warehouse, $store.state.transport.air) }} /KG
              </td> -->
            </tr>
          </template>
          <tr>
            <td>稅金</td>
            <td>
              <v-layout class="my-2">
                <v-spacer />
                <!-- <div
                  class="mr-2"
                  @click="viewAirFeeType='frt'"
                >
                  <v-icon
                    v-if="viewAirFeeType==='frt'"
                    small
                    class="blue--text">radio_button_checked</v-icon>
                  <v-icon
                    v-else
                    small>radio_button_unchecked</v-icon>
                  包頻繁稅
                </div> -->
                <div
                  class="mr-2 cursor-pointer"
                  @click="viewAirFeeType='busi'"
                >
                  <v-icon
                    v-if="viewAirFeeType==='busi'"
                    small
                    class="blue--text"
                  >
                    radio_button_checked
                  </v-icon>
                  <v-icon
                    v-else
                    small
                  >
                    radio_button_unchecked
                  </v-icon>
                  不包稅
                </div>
                <div
                  class="cursor-pointer"
                  @click="viewAirFeeType='tax'"
                >
                  <v-icon
                    v-if="viewAirFeeType==='tax'"
                    small
                    class="blue--text"
                  >
                    radio_button_checked
                  </v-icon>
                  <v-icon
                    v-else
                    small
                  >
                    radio_button_unchecked
                  </v-icon>
                  全包稅
                </div>
                <v-spacer />
              </v-layout>
            </td>
          </tr>
          <tr>
            <td>派送</td>
            <td>
              黑貓<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText />
              </Tooltips>
              新竹<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText />
                <v-divider class="my-2" />
                <h4>標準尺寸：</h4>
                <HctCaiStandardText transport="air" />
                <v-divider class="my-2" />
                <h4>超才費：</h4>
                <HctCaiFeeText transport="air" />
                <v-divider class="my-2" />
                <h4>棧板費：</h4>
                <HctHatPalletFeeText />
              </Tooltips>
              大榮<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText carrier="ktj" />
              </Tooltips>
            </td>
          </tr>
          <tr>
            <td>合包上限</td>
            <td>每筆訂單集運上限30個包裹</td>
          </tr>
        </table>
      </v-tab-item>
      <v-tab-item
        v-if="seType[0]"
        lazy
      >
        <table
          class="shippingRateTable"
        >
          <!-- <tr>
            <td width="80">
              起始重量
            </td>
            <td>
              {{ seType[0].minWeight | toKg }} KG
              ，不足 {{ seType[0].minWeight | toKg }}KG 按 {{ seType[0].minWeight | toKg }}KG 計
            </td>
          </tr>
          <tr v-if="seNoTax">
            <td>個人用途包稅（海關要求轉正式報關、單件超重轉正式報關、您主動要求繳稅報關不在包稅範圍）</td>
            <td>NT$ {{ seNoTax.fwFee }} /KG</td>
          </tr>
          <tr v-if="seTax">
            <td>不包稅</td>
            <td>NT$ {{ seTax.fwFee }} /KG</td>
          </tr> -->

          <tr>
            <td width="70">
              運費
            </td>
            <td>
              <template v-if="viewSeFeeType==='frt'">
                NT$ {{ $calc.add(seType[0].fwFee, seType[0].frtFee) }} / KG
              </template>
              <template v-else-if="viewSeFeeType==='tax'">
                NT$ {{ $calc.add(seType[0].fwFee, seType[0].taxFee) }} / KG
              </template>
              <template v-else>
                NT$ {{ seType[0].fwFee }} / KG
              </template>
            </td>
          </tr>
          <tr>
            <td>
              承運標準
            </td>
            <td>
              <!-- NT$ {{ seNoTax.fwFee * (seType[0].minWeight / 1000) }} / {{ seType[0].minWeight / 1000 }}KG -->
              合包後需超過5KG
              <Tooltips>
                不滿5公斤以5公斤計費
              </Tooltips>
            </td>
          </tr>
          <tr>
            <td>稅金</td>
            <td class="px-0">
              <v-layout
                justify-space-around
                class="mx-0 my-2"
              >
                <div
                  class="cursor-pointer"
                  @click="viewSeFeeType='busi'"
                >
                  <v-icon
                    v-if="viewSeFeeType==='busi'"
                    small
                    class="blue--text"
                  >
                    radio_button_checked
                  </v-icon>
                  <v-icon
                    v-else
                    small
                  >
                    radio_button_unchecked
                  </v-icon>
                  不包稅
                </div>
                <div
                  class="cursor-pointer"
                  @click="viewSeFeeType='frt'"
                >
                  <v-icon
                    v-if="viewSeFeeType==='frt'"
                    small
                    class="blue--text"
                  >
                    radio_button_checked
                  </v-icon>
                  <v-icon
                    v-else
                    small
                  >
                    radio_button_unchecked
                  </v-icon>
                  包頻繁稅
                </div>
                <div
                  class="cursor-pointer"
                  @click="viewSeFeeType='tax'"
                >
                  <v-icon
                    v-if="viewSeFeeType==='tax'"
                    small
                    class="blue--text"
                  >
                    radio_button_checked
                  </v-icon>
                  <v-icon
                    v-else
                    small
                  >
                    radio_button_unchecked
                  </v-icon>
                  全包稅
                </div>
              </v-layout>
            </td>
          </tr>
          <tr>
            <td>派送</td>
            <td>
              <!-- 新竹（標準尺寸<Tooltips><HctCaiStandardText/></Tooltips>、超才費<Tooltips><HctCaiFeeText/></Tooltips>、棧板費<Tooltips><HctHatPalletFeeText/></Tooltips>） -->
              新竹<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText />
                <v-divider class="my-2" />
                <h4>標準尺寸：</h4>
                <HctCaiStandardText transport="se" />
                <v-divider class="my-2" />
                <h4>超才費：</h4>
                <HctCaiFeeText transport="se" />
                <v-divider class="my-2" />
                <h4>棧板費：</h4>
                <HctHatPalletFeeText />
              </Tooltips>
              大榮<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText carrier="ktj" />
              </Tooltips>
              通盈<Tooltips>
                <h4>離島費用：</h4>
                <LandFeeText carrier="ty" />
              </Tooltips>
            </td>
          </tr>
          <tr>
            <td>合包上限</td>
            <td>每筆訂單集運上限30個包裹</td>
          </tr>
        </table>
      </v-tab-item>
      <v-tab-item
        v-if="seaType[0]"
        lazy
      >
        <table
          class="shippingRateTable"
        >
          <!-- <tr>
            <td width="80">
              起始重量
            </td>
            <td>
              {{ seType[0].minWeight | toKg }} KG
              ，不足 {{ seType[0].minWeight | toKg }}KG 按 {{ seType[0].minWeight | toKg }}KG 計
            </td>
          </tr>
          <tr v-if="seNoTax">
            <td>個人用途包稅（海關要求轉正式報關、單件超重轉正式報關、您主動要求繳稅報關不在包稅範圍）</td>
            <td>NT$ {{ seNoTax.fwFee }} /KG</td>
          </tr>
          <tr v-if="seTax">
            <td>不包稅</td>
            <td>NT$ {{ seTax.fwFee }} /KG</td>
          </tr> -->
          <tr>
            <td width="80">
              運費
            </td>
            <td>
              NT$ {{ seaType[0].fwFee }}元/KG 80元/才 兩者取大
            </td>
          </tr>
          <tr>
            <td>
              承運標準
            </td>
            <td>
              <!-- NT$ {{ seNoTax.fwFee * (seType[0].minWeight / 1000) }} / {{ seType[0].minWeight / 1000 }}KG -->
              訂單不足{{ seaType[0].minWeight | toKg }}KG按{{ seaType[0].minWeight | toKg }}KG收費
            </td>
          </tr>
          <tr>
            <td>稅金</td>
            <td>全包稅</td>
          </tr>
          <tr>
            <td>派送</td>
            <td>
              呼力捷
            </td>
          </tr>
        </table>
      </v-tab-item>
    </v-tabs>

    <!-- <div>
      <ShippingRatesCalc
        v-if="currentSrItem"
        ref="ShippingRatesCalc"
        :srItem="currentSrItem"
      />
    </div> -->
  </div>
</template>

<script>
import VolumeTips from './VolumeTips'
import ForbidTips from './ForbidTips'
import SeForbidTips from './SeForbidTips'
import IndemnityTips from './IndemnityTips'
import ShippingRatesCalc from './ShippingRatesCalc'
import HctHatPalletFeeText from '@g/components/Text/HctHatPalletFeeText'
import HctCaiFeeText from '@g/components/Text/HctCaiFeeText'
import HctCaiStandardText from '@g/components/Text/HctCaiStandardText'
import ShpMethodBusinessText from '@g/components/Text/ShpMethodBusinessText'
import LandFeeText from '@g/components/Text/LandFeeText'

export default {
  components: {
    VolumeTips,
    ForbidTips,
    SeForbidTips,
    IndemnityTips,
    ShippingRatesCalc,
    HctHatPalletFeeText,
    HctCaiFeeText,
    HctCaiStandardText,
    ShpMethodBusinessText,
    LandFeeText,
  },
  props: {
    addrid: String
  },
  data () {
    return {
      tabIndex: 0,
    }
  },
  computed: {

    viewAirFeeType: {
      get () {
        return this.$store.state.shippingRate.viewAirFeeType
      },
      set (v) {
        this.$store.commit('shippingRate/setViewAirFeeType', v)
      }
    },
    viewSeFeeType: {
      get () {
        return this.$store.state.shippingRate.viewSeFeeType
      },
      set (v) {
        this.$store.commit('shippingRate/setViewSeFeeType', v)
      }
    },
    warehouse () {
      return this.$store.state.jyWarehouses.find(item => item.addrid === this.addrid)
    },
    jyShippingRatesSourceByCurrent () {
      return this.$store.state.jyShippingRatesSource
        .filter(item => item.addrid === '1769' || item.addrid === this.addrid)
    },
    jyShippingRatesSource () {
      const arr = []
      this.jyShippingRatesSourceByCurrent.forEach(item => {
        if (item.firstWeight > 0) {
          arr.push(item)
        } else {
          // 重量範圍
          const weightRanges = this.formatWeightRanges(item)
          weightRanges.forEach((weight, index) => {
            arr.push({
              ...item,
              weightRange: {
                start: this.$options.filters.toKg(weight.start),
                end: weight.end < this.$store.state.shippingRate.weightRangeMax
                  ? this.$options.filters.toKg(weight.end)
                  : null
              },
              firstWeight: '1000',
              fwFee: weight.fee
            })
          })
        }
      })
      return arr
    },
    airTypeTwp () {
      return this.getType(this.$store.state.transport.air).find(item => item.type === 'twp')
    },
    airTypeTwt () {
      return this.getType(this.$store.state.transport.air).find(item => item.type === 'twt')
    },
    seType () {
      return this.getType(this.$store.state.transport.se)
    },
    seaType () {
      return this.getType(this.$store.state.transport.sea)
    },
    seTax () { // 不包稅
      return this.jyShippingRatesSourceByCurrent.find(rate => {
        return rate.transport === 'se' && rate.taxFee === '-1'
      })
    },
    seNoTax () { // 包稅
      return this.jyShippingRatesSourceByCurrent.find(rate => {
        return rate.transport === 'se' && rate.taxFee === '0'
      })
    },
    currentSrItem () {
      if (this.tabIndex === 0) {
        return this.jyShippingRatesSourceByCurrent.find(rate => {
          return rate.transport === 'air' && rate.type === 'twp'
        })
      }
      if (this.tabIndex === 1) {
        return this.jyShippingRatesSourceByCurrent.find(rate => {
          return rate.transport === 'air' && rate.type === 'twt'
        })
      }
      if (this.tabIndex === 2) {
        return this.jyShippingRatesSourceByCurrent.find(rate => {
          return rate.transport === 'se'
        })
      }
      if (this.tabIndex === 3) {
        return this.jyShippingRatesSourceByCurrent.find(rate => {
          return rate.transport === 'sea'
        })
      }
      return null
    },
  },
  watch: {
    // tabIndex () {
    //   if (this.$refs.ShippingRatesCalc.calcForm.weight > 0) {
    //     this.$refs.ShippingRatesCalc.startCalc()
    //   }
    // },
    currentSrItem: {
      handler () {
        this.$emit('changeSrItem', this.currentSrItem)
      },
      immediate: true
    }
  },
  methods: {
    getType (transport) {
      const arr = []
      this.jyShippingRatesSourceByCurrent.forEach(rate => {
        if (arr.findIndex(item => item.type === rate.type) === -1 && rate.transport === transport) {
          rate = { ...rate }
          if (rate.firstWeight > 0) {
          } else {
            // 重量範圍
            const weightRanges = this.formatWeightRanges(rate)
            rate.weightRanges = weightRanges
          }
          arr.push(rate)
        }
      })
      return arr
    },
    formatFee (rage, warehouse, transport) {
      const shippingRate = this.jyShippingRatesSource.find(item => {
        return item.addrid === warehouse.addrid && item.type === rage.type && item.transport === transport
      })
      if (!shippingRate) {
        return '--'
      }
      if (rage.weightRange) {
        const range = this.formatWeightRanges(shippingRate)
          .find(item => this.$options.filters.toKg(item.start) === rage.weightRange.start)
        if (!range) {
          return '--'
        }
        return range.fee
      }
      return shippingRate.fwFee
    },
    // 格式化重量範圍
    formatWeightRanges: function (sr) {
      return this.$store.getters['shippingRate/formatWeightRanges'](sr)
    }
  }
}
</script>

<style lang="postcss" scoped>
.shippingRateTable {
  border: 0;
  border-collapse: collapse;
  width: calc(100% + 1px);
  text-align: center;
  line-height: 1.2;
  th,
  td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 6px 5px;
  }
}
</style>
<style lang="postcss">
.ShippingRateRoot {
  .v-tabs__item {
    padding: 6px 7px;
  }
}
</style>
